module.exports = __webpack_public_path__ + "static/scale-model-of-sioux-falls-south-dakota-a4742d2d3e2c03c22fee37e04fbc5e4d.png";